// extracted by mini-css-extract-plugin
export default {"container":"Personal_container__JxJqd"};